/* eslint-disable import/prefer-default-export */
import { motion } from 'framer-motion'
import styled from 'styled-components'

import { hFlex } from '../../../styles/style-helpers'

export const FaqEl = styled.div``

export const ItemEl = styled(motion.div)`
  border: 1px solid #d0d0d0;
  border-radius: 0.25em;
  padding: 1em;
  margin: 1em 0;
  line-height: 1.5;

  .question {
    ${hFlex};
    justify-content: space-between;

    svg {
      font-size: 1.25em;
      opacity: 0.7;
      transform: ${({ isActive }) => (isActive ? 'rotate(45deg)' : 'none')};
      transition: transform 500ms ease;
      margin-left: 1em;
    }
  }

  .answer {
    overflow: hidden;
    display: block;

    span {
      display: block;
      margin-bottom: 1em;

      &:last-of-type {
        margin-bottom: 0;
      }
    }

    &:before {
      position: relative;
      content: '';
      height: 1em;
      width: 100%;
      display: block;
    }
  }
`
